import 'css-chunksrc/client/scenes/wbs/task/allocationsList/details/allocation/completion/styles.scss';export default {
  "progressBar": "_progressBar_1p6b6_1",
  "textProgressIndicator": "_textProgressIndicator_1p6b6_10"
};